export default "__VITE_ASSET__DyzGUW9X__"